<div [ngClass]="{'empty': empty}">{{!empty ? initials : ''}}</div>